import { trackGALegacyEvent } from 'gcs-common/slices/googleAnalytics/googleAnalyticsThunks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type GAEvent = {
  category: string;
  action: string;
};

const useTrackOncePerSession = ({
  event,
  eventKey,
  skip = false,
}: {
  event: GAEvent;
  eventKey: string;
  skip?: boolean;
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (skip) {
      return;
    }

    const eventFired = sessionStorage.getItem(eventKey);

    if (!eventFired) {
      dispatch(trackGALegacyEvent(event));
      // Record the event in session storage to prevent it from firing again
      sessionStorage.setItem(eventKey, 'true');
    }
  }, [dispatch, event, eventKey, skip]);
};

export default useTrackOncePerSession;
